import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import './assets/css/Style.css';
import ConditionNav from './component/ConditionNav';
import Header from './component/Header';
import Footer from './component/Footer';
import Login from './pages/Login';
import Catagory from './pages/Catagory';
import CatagoryDetails from './pages/CatagoryDetails';
import BackToTop from './component/BackToTop';
import './i18n';
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

function App() {
    return (
        <>
            <Router basename={process.env.PUBLIC_URL}>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/catagory" element={<Catagory />} />
                    <Route path="/catagory-details" element={<CatagoryDetails />} />
                </Routes>
                <Footer />
                <BackToTop />
            </Router>
        </>
    );
}

export default App; 